
/* ********************************** */
/* ***** Barracuda Slideshow v4 ***** */
/* ********************************** */
customElements.define('barracuda-slideshow-timeline', class BarracudaSlideshowTimeline extends HTMLElement{
    constructor(){
        super()
    }
    connectedCallback() {
        this.slideshow = this.closest("barracuda-slideshow-core")
        defer((()=>{
            this.timeSlider = document.createElement("span")
            this.timeSlider.classList.add("time-slider")
            this.appendChild(this.timeSlider)
    
            if (this.slideshow) {
                if (this.getAttribute('width-as')){
                    this.widthElement = this.slideshow.querySelector("#" + this.getAttribute('width-as'));
                    if (this.widthElement) {
                        setTimeout(this.setSize.bind(this), 100)
                        this.widthElement.addEventListener("DOMchange", this.setSize.bind(this))
                    }
                }
    
                if(this.slideshow.getAttribute("autoplay") == "true")
                    this.stateChange("playing")
                
                if (this.slideshow.getAttribute("time-on-slide"))
                    this.setTime(this.slideshow.getAttribute("time-on-slide"))
                
                this.slideshow.addEventListener("slideshow:state:change", ((event)=>{
                    let state = event.detail.state
                    if(state) this.stateChange(state)
                }).bind(this))
            }
        }).bind(this))
        
    }
    setTime(time) {
        this.timeSlider.style.setProperty("--duration", ( parseInt(time) * 1000 - 20) + 'ms')
    }
    setSize() {
        this.style.width = this.widthElement.scrollWidth + "px";
    }
    stateChange(state) {
        if (state == "playing") {
            this.renewState();
            this.style.opacity = 1
        } else if (state == "paused") {
            this.timeSlider.classList.remove("running")
            this.style.opacity = 0;
        }
    }
    renewState() {
        this.timeSlider.classList.remove("running")
        setTimeout((() => { this.timeSlider.classList.add("running") }).bind(this), 10);
    }
})
customElements.define('barracuda-slideshow-button', class BarracudaSlideshowButton extends HTMLElement{
    constructor(){
        super()
        this.slideshow = this.closest("barracuda-slideshow-core")
        if(this.slideshow){
            this.addEventListener("click", ()=>{
                let action = this.getAttribute("action")
                if(action)
                this.slideshow.dispatchEvent(new CustomEvent('slideshow:action',{detail:{"action": action }}))
            })
        }
    }
})
customElements.define('barracuda-slideshow-button-cursor', class extends HTMLElement {
    constructor() {
      super();
      this.icon = this.querySelector('.google-icon');
      this.icon.style.position = 'absolute';
    }
  
    connectedCallback() {
        this.addEventListener('mousemove', (event) => {
          if (this.icon) {
            // Get the boundaries of the element
           const rect = this.getBoundingClientRect();
           const minX = rect.left;
           const minY = rect.top;
           const maxX = rect.width;
           const maxY = rect.height;
     
           // Calculate the position of the cursor relative to the element
           const x = event.clientX - minX;
           const y = event.clientY - minY;
     
           // Restrict the movement of the icon within the boundaries of the element
           const iconWidth = this.icon.offsetWidth;
           const iconHeight = this.icon.offsetHeight;

           const iconX = Math.min(Math.max(x - iconWidth / 2, 0 - 48), maxX - iconWidth + 48);
           const iconXsafe = Math.min(Math.max(x - iconWidth / 2, 0), maxX - iconWidth);

           const iconY = Math.min(Math.max(y - iconHeight / 2, 0), maxY - iconHeight);
      
            iconX != iconXsafe? this.icon.classList.add("not-visible") : this.icon.classList.remove("not-visible");
            
            // Move the icon to the new position
            this.icon.style.left = `${iconX}px`;
            this.icon.style.top = `${iconY}px`;
          }
        });
      
        this.addEventListener('click', this.whenClick.bind(this));
      }
  
    whenClick() {
      this.slideshow = this.closest('barracuda-slideshow-core');
      if (this.slideshow) {
        let action = this.getAttribute('action');
        if (action) {
          this.slideshow.dispatchEvent(new CustomEvent('slideshow:action', {
            detail: {
              'action': action
            }
          }));
        }
      }
    }
  });
  
customElements.define('barracuda-slideshow-state', class BarracudaSlideshowState extends HTMLElement{
    constructor(){
        super()
        this.slideshow = this.closest("barracuda-slideshow-core")
        this.state = this.slideshow.getAttribute("autoplay")
        if(this.state == 'true') this.stateChange("playing")
        else this.stateChange("paused")

        this.slideshow.addEventListener("slideshow:state:change", ((event)=>{
            let state = event.detail.state
            if(state) this.stateChange(state)
        }).bind(this))
    }
    stateChange(state){
        this.querySelectorAll(".state:not(." + state + ")").forEach(element => {
            element.classList.add("hidden")
        })
        this.querySelectorAll(".state."+state).forEach(element => {
            element.classList.remove("hidden")
        })
    }
})

class Timer {
    constructor(fn, countdown){
        this.complete = false;
        this.fn = fn;
        this.countdown = countdown;
        this.start_time = new Date().getTime();
        this.ident = setTimeout(fn, countdown);
        this.state = 1;
    }
    

    time_diff(date1, date2) {
        return date2 ? date2 - date1 : new Date().getTime() - date1;
    }

    cancel() {
        clearTimeout(this.ident);
    }

    pause() {
        this.state = 0;
        clearTimeout(this.ident);
        this.total_time_run = this.time_diff(this.start_time);
        this.complete = this.total_time_run >= this.countdown;
    }

    resume() {
        if(!this.state){
            this.state = 1;
            this.ident = this.complete ? this.fn() : setTimeout(this.fn, this.countdown - this.total_time_run);
        }
    }

}

customElements.define('barracuda-slideshow-core', class BarracudaSlideshowCore extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {

        // init section
        this.init()

        // add event listeners
        defer((()=>{
            this.addEventListener("slideshow:action", event=>{
                switch (event.detail.action) {
                    case "set":
                        this.set(event.detail.nth)
                        break;
                    default:
                        this[event.detail.action]()
                        break;
                }
            })
            if (Shopify.designMode) {
                document.addEventListener("shopify:block:select", (event => {
                    if(event.detail.sectionId == this.getAttribute('section-id')){
                        let block = this.querySelector("#shopify-block-" + event.detail.blockId)
                        if(block){
                            this.set(parseInt(block.dataset.nth), 0)
                        }
                        this.pause()
                        this.setHeight()
                    }
                }).bind(this));
                document.addEventListener("shopify:block:deselect", (event => {
                    if(event.detail.sectionId == this.getAttribute('section-id')){
                        this.play()
                        this.setHeight()
                    }
                }).bind(this));
                document.addEventListener("shopify:section:load", (event => {
                    if(event.detail.sectionId == this.getAttribute('section-id')){
                        this.init()
                    }
                }).bind(this));
            }
        }).bind(this))
    }
    unmute(){
      this.unmuted = true;
      this.current.element.querySelectorAll('video').forEach(el=>{
        el.muted = false;
      })
    }
    init(){
        this.unmuted = false;
        // Select all slides in slideshow
        this.slides = this.querySelectorAll(".slide")
        // Find first slide (defined with current or first child)
        let firstSlide = this.querySelector(".slide.current")? this.querySelector(".slide.current") : (this.querySelector(".slide")? this.querySelector(".slide") : false)
        // If we have slides and one as current, we can continue in working
        if(this.slides){
            // Define current slide
            this.current = {
                "index" : parseInt(firstSlide.dataset.nth),
                "element" :  firstSlide
            }
          
                        
            // Check slideshow height
            this.setHeight()
            window.addEventListener("resize",this.setHeight.bind(this))

            // if slide doesn't have the current class, add it
            this.current.element.classList.add("current")

            // Get current slide color and adapt slideshow to it
            this.setColors(this.current.element);

            defer((()=>{
                // Check autoplay attribute and start playing
                if(this.getAttribute("autoplay") == 'true') this.play()
                if(this.slides.length > 1){
                    this.controlAnimations();
                    window.addEventListener('scroll', this.controlAnimations.bind(this), false)
                }
            }).bind(this))

        }else{
            // Oterwise send error
            console.log("BarracudaSlideshowCore: 1 slide is minimum")
        }
    }
    controlAnimations(){
        const rect = this.getBoundingClientRect()
        if(rect.top < window.innerHeight && rect.bottom > 0){
            this.classList.remove('out-of-view')
            if(this.timeout) this.timeout.resume()
        }else{
            this.classList.add('out-of-view')
            if(this.timeout) this.timeout.pause()
        }
    }
    next(){
        // check if next exist otherwise set first
        let nextIndex = (this.slides.length > this.current.index + 1)? this.current.index + 1 : 0
        this.set(nextIndex)
    }
    before(){
        // check if previous exist otherwise set first
        let nextIndex = (0 <= this.current.index - 1)? this.current.index - 1 : this.slides.length - 1
        this.set(nextIndex)
    }
    setColors(element) { 
        let color = getComputedStyle(element).getPropertyValue('--text_color')
        this.style.setProperty('--text_color', color)
        let backgroundColor = getComputedStyle(element).getPropertyValue('--background_color')
        this.style.setProperty('--background_color', backgroundColor)

        if (element.getAttribute("inverted")){
            this.closest('.shopify-section').classList.add("use-inverted-colors")
        }else {
            this.closest('.shopify-section').classList.remove("use-inverted-colors")
        }

        document.dispatchEvent(new CustomEvent("section:colorChange"))
    }
    setHeight() {
        this.style.setProperty("--largest-height", "0px")
        // init minimum
        let largestHeight = 0
        // check all slides
        this.slides.forEach(slide => {
            if (slide.scrollHeight > largestHeight) largestHeight = slide.scrollHeight
        })
        // set size as height
        this.style.setProperty("--largest-height", largestHeight + "px")
    }
    set(nth,withAnimation = true){
        // Check if slideshow isn't locked
        if(!this.lock){
            // Lock slideshow
            this.lock = true

            // Predefine next slide
            let to = { "index": nth, "element": this.slides[nth] }
            // Predefine current
            let from = this.current

            // Animate slides
            let animationDuration = withAnimation? 600 : 10
            this.style.setProperty('--animation-duration', animationDuration + 'ms');
            // Get target slide color and adapt slideshow to it
            this.setColors(to.element)

            // Animate text AOS
            if(from.element.querySelector(".aos-init")) {
                let currentText = from.element.querySelector(".aos-init")
                setTimeout(() => {
                    currentText.classList.remove("aos-init", "aos-animate")
                    currentText.removeAttribute("data-aos")
                },1000)
                
                if (to.element.querySelector(".text-content")) {
                    let futureText = to.element.querySelector(".text-content")
                    futureText.style.opacity = 0;
                    setTimeout(() => {
                        futureText.setAttribute("data-aos","fade-up")
                    },6)
                }
            }
        
            setTimeout(()=>{
                from.element.classList.add("leaving")
                from.element.querySelectorAll('video').forEach(el=>{
                  el.muted = true;
                })
                to.element.classList.add("upcoming")
                // Dispatch event announcement
                this.dispatchEvent(new CustomEvent("slideshow:slide:unloaded",{ detail: {
                    "sectionId": this.getAttribute("section-id"),
                    "slide": from, "from": from, "to": to, "duration": animationDuration 
                }}))
                setTimeout(()=>{
                    from.element.classList.remove("current")
                    to.element.classList.add("current")
                    setTimeout(()=>{
                        from.element.classList.remove("leaving")
                        to.element.classList.remove("upcoming")

                        if(this.unmuted)
                          to.element.querySelectorAll('video').forEach(el=>{
                            el.muted = false;
                          })
                        // Save target as current 
                        this.current = to

                        // Animate AOS
                        if (to.element.querySelector(".text-content[data-aos=fade-up]")){
                            let futureText = to.element.querySelector(".text-content")
                            futureText.style.removeProperty("opacity")
                            futureText.classList.add("aos-init","aos-animate")
                        }

                        //Dispatch event announcement
                        document.dispatchEvent(new CustomEvent("slideshow:slide:loaded",{ detail: {
                            "sectionId": this.getAttribute("section-id"),
                            "slide": to, "from": from, "to": to, "duration": animationDuration 
                        }}))

                        // Unlock slideshow
                        this.lock = false
                        if(this.state == "playing") this.play()
                    },10)
                },animationDuration)
            },10)

        }
    }
    pause(){
        //If we have timeout then clear it
        if(this.timeout){
            this.timeout.cancel()
            this.timeout = null;
        }
        this.state = "paused"
        // dispatch state
        this.dispatchEvent(new CustomEvent("slideshow:state:change", {detail: {"state": "paused"}}))
    }
    play(){
        //If we have timeout then clear it
        if(this.timeout){
            this.timeout.cancel()
            this.timeout = null;
        }
        // Get time on slide or use default value (2s)
        let timeOnSlideCurrent = parseInt(this.current.element.getAttribute('time-on-slide')) * 1000
        console.log(timeOnSlideCurrent)
        let timeOnSlide = timeOnSlideCurrent
        //let timeOnSlide = parseInt(this.getAttribute('time-on-slide')? this.getAttribute('time-on-slide'): 2) * 1000
        // Start timer
        this.timeout = new Timer(this.next.bind(this),timeOnSlide)
        this.state = "playing"
        // dispatch state
        this.dispatchEvent(new CustomEvent("slideshow:state:change", {detail: {"state": "playing"}}))
    }
});